/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Dismiss_NotificationInputs */

const fr_common_dismiss_notification = /** @type {(inputs: Common_Dismiss_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la notification`)
};

const en_common_dismiss_notification = /** @type {(inputs: Common_Dismiss_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss notification`)
};

/**
* | output |
* | --- |
* | "Dismiss notification" |
*
* @param {Common_Dismiss_NotificationInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const common_dismiss_notification = /** @type {((inputs?: Common_Dismiss_NotificationInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Dismiss_NotificationInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_dismiss_notification(inputs)
	return fr_common_dismiss_notification(inputs)
});